var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('main', {
    staticClass: "clearfix"
  }, [_c('PageLoading')], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };